module.exports = __webpack_public_path__ + "static/media/greyjoy_token.2c8eb485.png";